<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">游戏现状态</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <el-button style="margin-bottom: 40px" size="mini" type="primary" @click="add">新增</el-button>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="id" label="id" width="150" />
              <el-table-column prop="type_name" label="名称" width="150" />
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
            <el-dialog title="删除" center width="40%" :visible.sync="deleteShow">
              <p style="text-align: center">确认删除吗？</p>
              <div slot="footer" class="dialog-footer">
                <el-button @click="delCancel">取 消</el-button>
                <el-button type="primary" @click="delSure">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gameManagementType, gameManagementTypeAdd, gameManagementTypeEdit, gameManagementTypeDel } from '@/api/dpartmentSmmary.js';
import Dialog from '../../common/Dialog';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      listQuery: {
        page: 1,
        limit: 10,
      },
      listLoading: false,
      tableData: [],
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增',
      dialogModel: [
        {
          type: 'el-input',
          label: '名称',
          prop: 'name',
        },
      ],
      deleteShow: false,
      deleteId: 0,
    };
  },
  created() {
    this.getList(this.listQuery);
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await gameManagementType(query);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data;
      this.listLoading = false;
    },
    // 删除
    async del(row) {
      this.deleteShow = true;
      this.deleteId = row.id;
    },
    // 取消删除
    delCancel() {
      this.deleteId = 0;
      this.deleteShow = false;
    },
    // 删除确定
    async delSure() {
      const { data } = await gameManagementTypeDel(this.deleteId);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.delCancel();
      this.getList(this.listQuery);
    },
    // 新增
    add() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.$refs.dialog.resetForm();
    },
    // 编辑
    async edit(row) {
      console.log(row);
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.$refs.dialog.resetForm();
      this.$refs.dialog.editForm({ id: row.id, name: row.type_name });
    },
    // 点击确定
    async dialogSure(form) {
      const { data } = this.dialogTitle === '新增' ? await gameManagementTypeAdd(form) : await gameManagementTypeEdit(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getList(this.listQuery);
    },
    // 点击关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
  },
};
</script>

<style>
</style>